module.exports = __webpack_public_path__ + "static/img/act-steps-pc.dadb790.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-pc.png
// module id = 9UDc
// module chunks = 1